export const getViewOverflowPosition = position => {
    if (position.parent[0] > position.child[0]) {
        return position.parent[0] - Math.abs(position.parent[0] - position.child[0]);
    }
    if (position.parent[1] < position.child[1]) {
        return position.parent[0] + Math.abs(position.parent[1] - position.child[1]);
    }
    return null;
};
